import { useCallback, useEffect, useState } from "react";
import { getData } from "../../../../../services/library";

// Contador independiente de la pestaña activa: se usa para la badge de
// "Pendientes Facturación", igual que en la pantalla original.
const usePendientesFacturacionCount = (desde, hasta) => {
  const [contador, setContador] = useState(0);

  const fetchContador = useCallback(() => {
    const sucursal = localStorage.getItem("suc_auth").split(",");
    getData(
      `/envasado_pedidos/cuentapendientes/${desde} 00:00:00/${hasta} 23:59:59/${sucursal}`,
      (data) => setContador(data?.[0]?.contador || 0)
    );
  }, [desde, hasta]);

  useEffect(() => {
    fetchContador();
  }, [fetchContador]);

  return { contador, refetchContador: fetchContador };
};

export default usePendientesFacturacionCount;
